module.exports = __webpack_public_path__ + "static/img/2.54488fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment/2.png
// module id = Zy9d
// module chunks = 1